import { defineComponent as _defineComponent } from 'vue'
import { HeadingDisplay, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { computed } from 'vue';
import { Money } from '@/modules/common/components/Money';
import {
  EProductViewCardType,
  IProduct
} from '@/modules/products/services/products';

interface Props {
  card: IProduct;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryCardMain',
  props: {
    card: null
  },
  setup(__props: any) {

const props = __props as {
  card: IProduct;
};



const isProduct = computed(
  () => props.card.type === EProductViewCardType.Product
);

const textColor = computed<NebraskaColors>(() =>
  props.card.amount!.value > 0
    ? NebraskaColors.elementPrimary
    : NebraskaColors.elementPlaceholder
);

return { __sfc: true,props, isProduct, textColor, HeadingDisplay, BaseText, NebraskaColors, Money }
}

})